import React, { useCallback } from "react";
import ProductForm from "../components/ProductForm";
import _ from "lodash";
import { connect } from "react-redux";
import {
    isSubmittingProduct,
    getSubmitProductFailure,
    actions
} from "../modules/market";
import useFetchProduct from "../components/useFetchProduct";
import Loading from "../components/Loading";

const UpdateProduct = connect(
    state => ({
        submittingProduct: isSubmittingProduct(state),
        failSubmitProduct: getSubmitProductFailure(state),
        dealer: state.dealers.currentDealer
    }),
    {
        udpateProduct: actions.updateProduct,
        deleteImage: actions.deleteProductImage
    }
)(
    ({
        submittingProduct,
        failSubmitProduct,
        udpateProduct,
        deleteImage,
        history,
        dealer,
        match: {
          params: { productId, dealer_id }
        }
    }) => {
        const dealerId = dealer_id || dealer.id;
        const { loading, product } = useFetchProduct({ productId, dealerId });
        const currentProduct = product;

        const onSubmit = useCallback(
            async values => {
                const data = {
                    product: _.pick(values, [
                        "name",
                        "description",
                        "price",
                        "images",
                        "has_tax"
                    ])
                };
                data.product.category_products_attributes = values.categories.map(
                    c => ({
                        id: c.id,
                        _destroy: c._destroy===1 ? 1 : 0
                    })
                );
                data.product.variants_attributes = values.variants;

                const result = await udpateProduct({ dealer_id: dealer.slug, productId: currentProduct.slug, data });
                if (result.response) {
                    history.push(`/products/${currentProduct.slug}`);
                }
            },
            [udpateProduct, dealer.slug, currentProduct, history]
        );
        
        if (loading) {
          return <Loading label="Loading product" />;
        }
        if (currentProduct) {
          return (
            <div>
              <h3><b>Update Product</b></h3>
                <ProductForm
                    submittingProduct={submittingProduct}
                    failSubmitProduct={failSubmitProduct}
                    onSubmit={onSubmit}
                    action='update'
                    product={currentProduct}
                    dealer={dealer}
                    deleteImage={deleteImage}
                />
            </div>
          );
        }
        return null;
    }
);

UpdateProduct.displayName = "UpdateProduct";

export default UpdateProduct;
